export default __webpack_public_path__ + "static/media/focusly.08f99aaf.png";